import { DuplicateId } from "@mcleod/dispatch";
import { AutogenLayoutCommentType } from "./autogen/AutogenLayoutCommentType";

export class CommentType extends AutogenLayoutCommentType {
    override onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "comment_type",
            screenName: this.titleSingular,
            navigateToUrl: `${this.layoutName}?mode=update&key=`
        });
    }
}
